module.exports = function anonymous(it
) {
var out='<li> ';if(it.html){out+=' '+(it.html)+' ';}else{out+=' <a class="js-menu js-menu-'+(it.id || it.name)+'" href="#/'+(it.href)+'" rel="localize[menu.'+(it.id || it.name)+']">'+(it.name)+'</a> ';}out+='</li>';return out;
}